import { render, staticRenderFns } from "./dubbingVideo.vue?vue&type=template&id=5a676d24&scoped=true"
import script from "./dubbingVideo.vue?vue&type=script&lang=js"
export * from "./dubbingVideo.vue?vue&type=script&lang=js"
import style0 from "./dubbingVideo.vue?vue&type=style&index=0&id=5a676d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a676d24",
  null
  
)

export default component.exports